export default __webpack_public_path__ + "static/6mm_IRcut-62913703dbad78ff290a45c846c8f4a0.webp";